export class VatAddress {
  vatAddressId?: number;
  vatAddressBranchNo?: string;
  vatAddressName?: string;
  vatAddressTaxId?: string;
  vatAddressDetail?: string;
  vatAddressSubdistrict?: string;
  vatAddressDistrict?: string;
  vatAddressProvince?: string;
  vatAddressPostalCode?: string;

  constructor(Obj: any = {}) {
    this.vatAddressId = Obj.vatAddressId;
    this.vatAddressBranchNo = Obj.vatAddressBranchNo;
    this.vatAddressName = Obj.vatAddressName;
    this.vatAddressTaxId = Obj.vatAddressTaxId;
    this.vatAddressDetail = Obj.vatAddressDetail;
    this.vatAddressSubdistrict = Obj.vatAddressSubdistrict;
    this.vatAddressDistrict = Obj.vatAddressDistrict;
    this.vatAddressProvince = Obj.vatAddressProvince;
    this.vatAddressPostalCode = Obj.vatAddressPostalCode;
  }
}
